import { Action } from '../interfaces/CarrierLogisticCommons.interface';
import localizationActions from '../actions/localization/localizationActionstypes';
import { initialContextValue } from '../context/CarrierLogisticsCommonsContext';
import { DEFAULT_LOCALE } from '../constants/localisation';

export function localizationReducer(
  state = initialContextValue.localization,
  action: Action<string, Record<string, any>>
) {
  const { type, payload } = action;
  switch (type) {
    case localizationActions.SET_LOCALE:
      return {
          ...state,
          locale: payload || DEFAULT_LOCALE
      };
    
    default:
      return state;
  }
}

export default localizationReducer;
